<template>
  <div>
    <section class="container">
      <div class="sub_contents_wrap">
        <seach-box
          v-bind:adSearchStatus="adSearchStatus"
          v-bind:searchWord="form.searchWord"
          v-bind:dataType="form.dataType"
          v-bind:totalSearch="totalSearch"
          @updateStatus="updateAdSearchStatus"
          @clickSearch="updateSubmit"
        >
        </seach-box>
        <div class="fillter_p_wrap">
          <div class="result_top_box">
            <p class="r_t_text">
              Search Results for: <strong>"{{ searchWordDisp }}"</strong>
            </p>
            <div class="r_t_right">
              <div class="btn-group">
                <a
                  class="btn btn-outline-secondary btn-lg toggle_arr"
                  href="#"
                  role="button"
                  id="dropdownPageSize"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ dispPageSize }}
                </a>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                  <li v-for="item of pageSizes" v-bind:key="item.value">
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click="updatePageSize(item.value, item.displayVal)"
                      >{{ item.displayVal }}</a
                    >
                  </li>
                </ul>
              </div>
              <div class="btn-group">
                <a
                  class="btn btn-outline-secondary btn-lg toggle_arr"
                  href="#"
                  role="button"
                  id="dropdownSort"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ dispSortField }}
                </a>
                <ul class="dropdown-menu" aria-labelledby="dropdownSort">
                  <li v-for="item of sortFields" v-bind:key="item.value">
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click="updateSortField(item.value, item.displayVal)"
                      >{{ item.displayVal }}</a
                    >
                  </li>
                </ul>
              </div>
              <div class="btn-group">
                <a
                  class="btn btn-outline-secondary btn-lg toggle_arr"
                  href="#"
                  role="button"
                  id="dropdownOrder"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ dispOrder }}
                </a>
                <ul class="dropdown-menu" aria-labelledby="dropdownOrder">
                  <li v-for="item of sortOrders" v-bind:key="item.value">
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click="updateSortOrder(item.value, item.displayVal)"
                      >{{ item.displayVal }}</a
                    >
                  </li>
                </ul>
              </div>
              <button class="btn btn-primary btn-lg" @click="clickSearch">Confirm</button>
            </div>
          </div>
          <div class="wrap_con">
            <div class="left_con">
              <div class="fillter_left_box">
                <h4>
                  <span>{{ $t("product.filter") }}</span
                  ><a href="#" class="l_fillter_bt" @click="changeShowFilter()"
                    ><em>Fillter</em></a
                  >
                </h4>
                <div class="fillter_inner">
                  <div
                    class="fillter_group_box"
                    v-bind:class="{ f_g_active: filterShow.product }"
                  >
                    <p>
                      <a href="#" @click="changeShowProductFilter()">{{
                        $t("product.product")
                      }}</a>
                    </p>
                    <ul v-if="productFacet" v-show="filterShow.product">
                      <li v-for="(item, index) in productFacet" :key="index">
                        <label class="facet_chk_text"
                          ><input
                            type="checkbox"
                            class="facet_chk"
                            :value="item.id"
                            v-model="form.paramProductList"
                            @change="onChangeChild(item.id), changeFilter()"
                          />{{ item.name }} ({{ item.count }})</label
                        >
                        <ul
                          v-if="item.children && item.children.length > 0"
                          class="f_g_child"
                          v-bind:class="{ f_g_active: filterShow.product2 }"
                        >
                          <p>
                            <a href="#" @click="changeShowProduct2Filter()"
                              >Product2Level {{ item.children.length }}
                              {{ item.children }}</a
                            >
                          </p>
                          <li
                            v-for="(citem, cindex) in item.children"
                            :key="cindex"
                            v-show="filterShow.product2"
                          >
                            <label class="facet_chk_text"
                              ><input
                                type="checkbox"
                                class="facet_chk"
                                :value="citem.id"
                                v-model="form.paramProductList"
                                @change="onChangeChild(citem.id), changeFilter()"
                              />{{ citem.name }} ({{ citem.count }})</label
                            >
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div
                    class="fillter_group_box"
                    v-bind:class="{ f_g_active: filterShow.doctype }"
                  >
                    <p>
                      <a href="#" @click="changeShowDoctypeFilter()">{{
                        $t("product.documentType")
                      }}</a>
                    </p>
                    <ul v-if="doctypeFacet" v-show="filterShow.doctype">
                      <li v-for="(item, index) in doctypeFacet" :key="index">
                        <label class="facet_chk_text"
                          ><input
                            type="checkbox"
                            class="facet_chk"
                            :value="item.id"
                            v-model="form.docType"
                            @change="changeFilter()"
                          />{{ item.name }} ({{ item.count }})</label
                        >
                      </li>
                    </ul>
                  </div>

                  <div
                    class="fillter_group_box"
                    v-bind:class="{ f_g_active: filterShow.exhaust }"
                  >
                    <p>
                      <a href="#" @click="changeShowExhaustFilter()">{{
                        $t("product.cerfication")
                      }}</a>
                    </p>
                    <ul v-if="exhaustFacet" v-show="filterShow.exhaust">
                      <li v-for="(item, index) in exhaustFacet" :key="index">
                        <label class="facet_chk_text"
                          ><input
                            type="checkbox"
                            class="facet_chk"
                            :value="item.id"
                            v-model="form.paramExhaustCertiList"
                            @change="changeFilter()"
                          />{{ item.name }} ({{ item.count }})</label
                        >
                      </li>
                    </ul>
                  </div>

                  <div
                    class="fillter_group_box"
                    v-bind:class="{ f_g_active: filterShow.lang }"
                  >
                    <p>
                      <a href="#" @click="changeShowLangFilter()">{{
                        $t("product.language")
                      }}</a>
                    </p>
                    <ul v-if="langFacet" v-show="filterShow.lang">
                      <li v-for="(item, index) in langFacet" :key="index">
                        <label class="facet_chk_text"
                          ><input
                            type="checkbox"
                            class="facet_chk"
                            :value="item.id"
                            v-model="form.paramLangList"
                            @change="changeFilter()"
                          />{{ item.name }} ({{ item.count }})</label
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="middle_con">
              <div class="f_w_box">
                <!-- PDF -->
                <div class="product_list_wrap">
                  <div class="s_r_group_box" v-if="this.pdfResultShow">
                    <h5 class="result_h5_title">
                      {{ pdfGroup.numFound ? pdfGroup.numFound : 0 }} Results
                    </h5>
                    <ul>
                      <li v-for="(item, index) in pdfGroup.documentList" :key="index">
                        <p class="p_l_bt_box">
                          <a
                            v-if="item.authWebhelpYn == 'Y' && item.ver_node_ref"
                            :href="
                              '/docview/model/lang/' +
                              item.ver_node_ref.replace('workspace://SpacesStore/', '') +
                              '/index.html'
                            "
                            target="_blank"
                            class="p_l_icon01"
                            title="Web View"
                            >WebHelp</a
                          >
                          <a
                            v-if="item.authViewYn == 'Y' && item.pdf_node_ref"
                            :href="
                              '/document/preview?noCache=' +
                              date +
                              '&uid=' +
                              item.pdf_node_ref.replace('workspace://SpacesStore/', '')
                            "
                            target="_blank"
                            class="p_l_icon04"
                            title="PDF View"
                            >View</a
                          >
                          <a
                            v-if="item.authDownloadYn == 'Y' && item.pdf_node_ref"
                            @click="showPDFDownloadPopup(item.doc_id, item.title)"
                            class="p_l_icon02"
                            title="PDF Download"
                            >PDF</a
                          >
                          <!-- <a
                            v-if="item.authDownloadYn == 'Y' && item.pdf_node_ref"
                            @click="
                              pdfDownload(
                                item.pdf_node_ref.replace('workspace://SpacesStore/', '')
                              )
                            "
                            class="p_l_icon02"
                            title="PDF Download"
                            >PDF</a
                          > -->
                          <a
                            v-if="item.authYn == 'Y'"
                            href="javascript:void(0);"
                            @click="showHistoryPopup(item.doc_id, item.title)"
                            class="p_l_icon03"
                            title="Version History"
                            >History</a
                          >
                        </p>
                        <a href="#" class="p_l_title">
                          <span v-if="item.model_name != null && item.model_name.length <= 2">
                            [{{ item.model_name.join(", ") }}]
                          </span>
                          <span v-else-if="item.model_name != null && item.model_name.length > 2">
                            [{{ item.model_name[0]+","+ item.model_name[1]}}...]
                          </span>
                          {{ item.doc_title }}
                          <em v-if="item.part_no != null && item.part_no != ''">
                            | {{ item.modelcode.join(", ") }} |
                            {{ item.exhaust.join(", ") }} | {{ item.doctype_enm }}
                            <span v-if="item.model_name != null"
                              >| {{ item.model_name.join(", ") }}</span
                            >
                            | {{ item.lang_name }} | {{ item.part_no }} |
                            {{ item.pubdate }}</em
                          >
                          <em v-else>
                            | {{ item.modelcode.join(", ") }} |
                            {{ item.exhaust.join(", ") }} | {{ item.doctype_enm }}
                            <span v-if="item.model_name != null"
                              >| {{ item.model_name.join(", ") }}</span
                            >
                            | {{ item.lang_name }} | {{ item.pubdate }}</em
                          >
                        </a>
                      </li>
                    </ul>
                  </div>

                  <!-- 데이터 없을때 -->
                  <div class="search_no_data" v-if="!this.pdfResultShow">
                    <span>Your search did not match any documents.</span>
                  </div>
                </div>

                <div v-if="pdfResultShow" class="paging_nav">
                  <ul class="">
                    <a
                      v-if="pagingVO.startPage <= pagingVO.blockSize"
                      class="page_select prev_page disabled"
                      href="javascript:void(0)"
                      >Previous</a
                    >
                    <a
                      v-else
                      class="page_select prev_page"
                      href="javascript:void(0)"
                      @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
                      v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
                      >Previous</a
                    >
                    <span
                      v-for="(pages, index) in pagingVO.currentBlockSize"
                      :key="index"
                    >
                      <li
                        v-if="pagingVO.startPage + index == pagingVO.currentPage"
                        class=""
                        aria-current="page"
                      >
                        <strong>{{ pagingVO.startPage + index }}</strong>
                      </li>
                      <li v-else class="">
                        <a
                          class=""
                          @click="searchPage(pagingVO.startPage + index)"
                          href="javascript:void(0)"
                          v-bind:data-page="pagingVO.startPage + index"
                          >{{ pagingVO.startPage + index }}</a
                        >
                      </li>
                    </span>
                    <a
                      v-if="pagingVO.endPage >= pagingVO.totalPage"
                      href="javascript:void(0)"
                      class="page_select next_page disabled"
                      >Next</a
                    >
                    <a
                      v-else
                      class="page_select next_page"
                      @click="searchPage(pagingVO.endPage + 1)"
                      href="javascript:void(0)"
                      v-bind:data-page="pagingVO.endPage + 1"
                      >Next</a
                    >
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--history 모달-->
      <HistoryModal
        id="historyModal"
        v-if="showModal"
        @close="showModal == false"
        :docId="form.docId"
        :docTitle="docTitle"
        ref="historyModal"
      >
        <template slot="footer">
          <button
            type="button"
            @click="closeModal"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            {{ $t("common.close") }}
          </button>
        </template>
      </HistoryModal>
    <!--PDF Download 모달-->
    <PDFDownloadModal
      id="pdfDownloadModal"
      :docId="form.docId"
      :docTitle="docTitle"
      v-if="showPDFModal"
      @close="showPDFModal == false"
      ref="historyModal"
    >
      <template slot="footer">
        <button
          type="button"
          @click="closePDFModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </PDFDownloadModal>
    </section>
    <advanced-search
      v-bind:adSearchStatus="adSearchStatus"
      v-bind:totalSearch="totalSearch"
      @update="updateAdSearchStatus"
      @clickSearch="submitAdvancedSearch"
    >
    </advanced-search>
  </div>
</template>

<script>
import router from "@/routes/index";
import { checkSession } from "@/api/login";
import { getSearchPdf } from "@/api/search";
import AdvancedSearch from "@/components/search/AdvancedSearch.vue";
import SeachBox from "@/components/search/SearchBox.vue";
import { preDownload } from "@/api/document";
import PDFDownloadModal from "@/components/modal/PDFDownloadModal";
import HistoryModal from "@/components/modal/HistoryModal";
import $ from "jquery";

export default {
  components: {
    AdvancedSearch,
    SeachBox,
    HistoryModal,
    PDFDownloadModal
  },
  data() {
    return {
      adSearchStatus: false,
      result: {},
      pagingVO: "",
      productFacet: [],
      doctypeFacet: [],
      exhaustFacet: [],
      modelcodeFacet: [],
      langFacet: [],
      pdfGroup: [],
      webhelpGroup: [],
      documentList: [],
      searchWordDisp: "",
      pdfResultShow: true,
      htmlResultShow: true,
      dispSortField: "Sort Field",
      dispOrder: "Order",
      dispPageSize: "Page Size",
      totalSearch: false,
      form: {
        searchWord: "",
        currentPage: 1,
        pageSize: 10,
        paramProductList: [],
        paramExhaustCertiList: [],
        paramLangList: [],
        docType: [],
        pubType: [],
        pubdate1: "",
        pubdate2: "",
        allVer: false,
        dataType: "suffix_model",
        withinSearch: false,
        preQuery: "",
        sortField: null,
        sortOrder: null,
        docId: "",
      },
      pageSizes: [
        { value: 10, displayVal: "10" },
        { value: 20, displayVal: "20" },
        { value: 50, displayVal: "50" },
        { value: 100, displayVal: "100" },
      ],
      sortFields: [
        { value: "relevance", displayVal: "Relevance" },
        { value: "title", displayVal: "Title" },
        { value: "pubdate", displayVal: "Published Date" },
      ],
      sortOrders: [
        { value: "desc", displayVal: "↓ (Descending)" },
        { value: "asc", displayVal: "↑ (Ascending)" },
      ],
      showModal: false,
      showPDFModal : false,
      filterShow: {
        product: true,
        product2: true,
        doctype: true,
        exhaust: true,
        lang: true,
      },
      docTitle: "",
      date: new Date().toISOString(),
    };
  },

  methods: {
    // Session 체크 후 검색페이지 load
    async checkSessionExist(){
      var loginUser = null;
      try {
          const response = await checkSession();
          loginUser = response.data.loginUser;
      } catch (error) {
          console.log(error);
      }
      if (loginUser == null) {
        router.push("/login");
      } else {
          this.$root.$emit("initMenuClassActive");
          if (this.$route.query.searchWord)
            this.form.searchWord = this.$route.query.searchWord;
          if (this.$route.params.page) this.form.page = this.$route.params.page;
          
          this.fetchData();
      }

    },
    async fetchData() {
      let loader = this.$loading.show({});
      try {
        const response = await getSearchPdf(this.form);
        this.result = response.data.result;
        this.productFacet = response.data.productFacet;
        this.doctypeFacet = response.data.doctypeFacet;
        this.exhaustFacet = response.data.exhaustFacet;
        this.modelcodeFacet = response.data.modelcodeFacet;
        this.langFacet = response.data.langFacet;
        this.form.preQuery = response.data.query;
        this.pagingVO = response.data.pagingVO;
        this.pdfGroup = response.data.searchResult;
        this.pdfResultShow = this.pdfGroup.documentList.length != 0;
        this.searchWordDisp = this.form.searchWord;
      } catch (error) {
        console.log(error);
      }
      loader.hide();
    },
    changeFilter() {
      this.form.currentPage = 1;
      this.fetchData();
    },
    updateSubmit(form) {
      this.form.searchWord = form.searchWord;
      this.form.dataType = form.dataType;
      this.form.pubType = []; // clean it if advanced search is executed.
      this.form.allVer = form.allVer;
      this.form.withinSearch = form.withinSearch;

      this.fetchData();
    },
    submitAdvancedSearch(payload) {
      // variables init
      this.form.paramProductList = [];
      this.form.docType = [];
      this.form.paramExhaustCertiList = [];

      this.form.searchWord = payload.searchWord;
      if (payload.prod_class) this.form.paramProductList.push(payload.prod_class);
      if (payload.prod_id) this.form.paramProductList.push(payload.prod_id);
      if (payload.certification)
        this.form.paramExhaustCertiList.push(payload.certification);

      this.form.docType = payload.doc_type;
      this.form.pubType = payload.pub_type; // equal to datatype
      this.form.pubdate1 = payload.pubdate1;
      this.form.pubdate2 = payload.pubdate2;

      this.fetchData();
    },
    //검색페이지
    clickSearch() {
      this.form.currentPage = 1;
      this.fetchData();
    },
    showHistoryPopup(docId, docTitle) {
      this.form.docId = docId;
      this.docTitle = docTitle;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.form.docId = "";
      this.docTitle = "";
    },
    closePDFModal() {
      this.showPDFModal = false;
      this.form.docId = "";
      this.docTitle = "";
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.currentPage = page;
      this.fetchData();
    },
    onChangeChild(prodId) {
      var checked = this.form.paramProductList.indexOf(prodId) > -1 ? true : false;
      for (var i = 0; i < this.productFacet.length; i++) {
        var currentProdId = this.productFacet[i].id;
        var children = this.productFacet[i].children;
        if (currentProdId == prodId && children != null) {
          for (var j = 0; j < children.length; j++) {
            if (checked) {
              this.form.paramProductList.push(children[j].id);
            } else {
              const idx = this.form.paramProductList.indexOf(children[j].id);
              if (idx > -1) this.form.paramProductList.splice(idx, 1);
            }
          }
        } else if (children != null) {
          var parentChecked =
            this.form.paramProductList.indexOf(currentProdId) > -1 ? true : false;
          var childChecked = false;
          for (j = 0; j < children.length; j++) {
            const idx = this.form.paramProductList.indexOf(children[j].id);
            if (idx > -1) childChecked = true;
          }
          if (!parentChecked && childChecked) {
            this.form.paramProductList.push(currentProdId);
          } else if (parentChecked && !childChecked) {
            const idx = this.form.paramProductList.indexOf(currentProdId);
            if (idx > -1) this.form.paramProductList.splice(idx, 1);
          }
        }
      }
    },
    updateAdSearchStatus(adSearch) {
      this.adSearchStatus = adSearch;
    },
    updateSortField(key, val) {
      this.form.sortField = key;
      this.dispSortField = val;

      this.updateSortOrder(this.sortOrders[0].value, this.sortOrders[0].displayVal);
    },
    updateSortOrder(key, val) {
      if (this.form.sortField == "relavance") {
        this.form.sortOrder = this.sortOrders[0].value;
        this.dispOrder = this.sortOrders[0].displayVal;
      } else {
        this.form.sortOrder = key;
        this.dispOrder = val;
      }
    },
    updatePageSize(key, val) {
      this.form.pageSize = key;
      this.dispPageSize = val;
    },
    changeShowFilter() {
      $(".fillter_inner").toggle();
    },
    changeShowProductFilter() {
      this.filterShow.product = !this.filterShow.product;
    },
    changeShowProduct2Filter() {
      this.filterShow.product2 = !this.filterShow.product2;
    },
    changeShowDoctypeFilter() {
      this.filterShow.doctype = !this.filterShow.doctype;
    },
    changeShowExhaustFilter() {
      this.filterShow.exhaust = !this.filterShow.exhaust;
    },
    changeShowLangFilter() {
      this.filterShow.lang = !this.filterShow.lang;
    },
    async pdfDownload(uid) {
      let loader = this.$loading.show({});

      const response = await preDownload(uid);
      if (response != null && response.data.status) {
        loader.hide();
        window.open("/document/download/pdf?uid=" + uid);
      } else {
        loader.hide();
        alert("Download failed");
      }
    },
    showPDFDownloadPopup(docId, docTitle){
        console.log(docId);
        console.log(docId);
        this.form.docId = docId;
        this.docTitle = docTitle;
        this.showPDFModal = true;
    }
  },
  created() {
    this.checkSessionExist();

    // if (this.$session.get("token") == null && this.$session.get("loginUser") == null) {
    //   router.push("/login");
    // } else {
    //   this.$root.$emit("initMenuClassActive");
    //   if (this.$route.query.searchWord)
    //     this.form.searchWord = this.$route.query.searchWord;
    //   if (this.$route.params.page) this.form.page = this.$route.params.page;
    //    this.fetchData();
    // }
  },
};
</script>

<style></style>
